import { formatKnuts } from '@/lib/pricing';
import { cn } from '@/lib/utils';

interface PriceDisplayProps {
  knuts: number;
  className?: string;
  compact?: boolean;
  /** ARIA label override; default expands G/S/K to "Galleons" etc. */
  ariaLabel?: string;
}

export function PriceDisplay({ knuts, className, compact, ariaLabel }: PriceDisplayProps) {
  const formatted = formatKnuts(knuts, { compact });
  const expanded = ariaLabel ?? formatted
    .replace(/(\d+)G/g, '$1 Galleons')
    .replace(/(\d+)S/g, '$1 Sickles')
    .replace(/(\d+)K/g, '$1 Knuts')
    .replace(/^~/, 'about ');
  return (
    <span
      aria-label={expanded}
      className={cn('font-display tabular-nums tracking-tight text-(--color-knut-bronze)', className)}
    >
      {formatted}
    </span>
  );
}
